import type { Agent } from '@fingerprint/agent';
import Fingerprint from '@fingerprint/agent';

export type FingerprintJsProOptions = {
	apiKey: string;
	endpoint?: string;
};

export default abstract class FingerprintService {
	public abstract getFingerprintId(): Promise<string>;
}

export class FingerprintJsProService extends FingerprintService {
	private readonly fpjs: Agent;
	private readonly startedAt: number;

	constructor(options: FingerprintJsProOptions) {
		super();
		this.fpjs = Fingerprint.start({
			apiKey: options.apiKey,
			endpoints: options.endpoint ? Fingerprint.withoutDefault(options.endpoint) : undefined,
		});
		this.startedAt = performance.now();
	}

	public async getFingerprintId(): Promise<string> {
		// v4 recommends one second of signal collection before identification.
		const remainingDelay = 1000 - (performance.now() - this.startedAt);
		if (remainingDelay > 0) {
			const { promise, resolve } = Promise.withResolvers<void>();
			setTimeout(resolve, remainingDelay);
			await promise;
		}

		const result = await this.fpjs.get();
		if (!result.visitor_id) {
			throw new Error('Fingerprint identification did not return a visitor ID');
		}
		return result.visitor_id;
	}
}
